import React from 'react';
import { OverlayTrigger, Popover, Table } from 'react-bootstrap';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';

import { formatCompletionPercentage, formatTime } from '../../../helpers/itpmetricsUtils';
import { __ } from '../../../helpers/translations';

function InfoPopover({ item, alignment = 'right' }) {
  return (
    <OverlayTrigger
      placement="top"
      overlay={(
        <Popover>
          <Popover.Body className="tooltip-popover">
            <Table borderless size="sm" className="tooltip-table">
              <tbody>
                {item.createdBy
                && (
                <tr>
                  <td>{__('G86')}</td>
                  <td>{item.createdBy}</td>
                </tr>
                )}
                <tr>
                  <td>{__('G87')}</td>
                  <td>{formatTime(item.surveyStartedAt)}</td>
                </tr>
                <tr>
                  <td>{__('G88')}</td>
                  <td>{formatTime(item.startedAt)}</td>
                </tr>
                <tr>
                  <td>{__('G89')}</td>
                  <td>{formatTime(item.completedAt)}</td>
                </tr>
                <tr>
                  <td>{__('G90')}</td>
                  <td>
                    {formatCompletionPercentage({
                      top: item.completedCount,
                      bottom: item.templateItemCount,
                    })}
                  </td>
                </tr>
              </tbody>
            </Table>
          </Popover.Body>
        </Popover>
              )}
    >
      <FontAwesomeIcon
        icon={faCircleInfo}
        style={
          alignment === 'right'
            ? { position: 'absolute', right: '40px', marginTop: '5px' }
            : { marginLeft: '10px', marginTop: '5px' }
        }
      />
    </OverlayTrigger>
  );
}
InfoPopover.propTypes = {
  item: PropTypes.object,
  alignment: PropTypes.oneOf(['left', 'right']),
};

export default InfoPopover;
